/**
 * Index page initialization
 * Simple landing page with trainer selection using TypeScript
 */

// Import CSS
import "./assets/css/main.css";
import "./assets/css/index.css";

// Log initialization
console.log("🏠 German Verb Trainer Index loaded (TypeScript)");
